import moment from 'moment'
export function dateFormat (value, formatO, formatI) {
  let _formatO = formatO || 'DD/MM/YYYY'
  let _formatI = formatI || 'YYYY-MM-DD'

  if (value) {
    return moment(value, _formatI).format(_formatO)
  } else {
    return null
  }
}

export function datetimeFormat (value, formatO, formatI) {
  let _formatO = formatO || 'DD/MM/YYYY HH:mm'
  let _formatI = formatI || 'YYYY-MM-DD HH:mm:ss'
  if (value) {
    return moment(value, _formatI).format(_formatO)
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/filters/date.js